import { captureException, withScope } from '@sentry/react';

type SentryCallback = (eventId: string) => void;

const reportError = (
  error: Error,
  extras?: Record<string, unknown>,
  callback?: SentryCallback
): void => {
  withScope(scope => {
    if (extras) {
      scope.setExtras(extras);
    }
    const eventId = captureException(error);

    if (callback) {
      callback(eventId);
    }
  });
};

export default reportError;
